<template>
    <v-tooltip
        top
        open-delay="1000"
        color="black"
    >
        <template #activator="{on, attrs}">
            <!--suppress HtmlUnknownAttribute -->
            <v-btn
                v-if="value"
                icon
                small
                type="button"
                color="primary"
                v-clipboard="value"
                v-bind="attrs"
                v-on="on"
            >
                <v-icon small>
                    fas fa-copy
                </v-icon>
            </v-btn>
        </template>
        <span>Copy field value to clipboard</span>
    </v-tooltip>
</template>
<script>
export default {
    props: {
        value: {
            type: String,
            required: true,
        }
    }
};
</script>
